import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';
import { AdminHeader } from './AdminHeader';

export const AdminLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navigation = [
    { name: 'Dashboard', href: '/admin/dashboard', icon: 'Home' },
    { name: 'Users', href: '/admin/users', icon: 'Users' },
    { name: 'Workspaces', href: '/admin/workspaces', icon: 'Building' },
    { name: 'Pricing', href: '/admin/pricing', icon: 'DollarSign' },
    { name: 'Invoices', href: '/admin/invoices', icon: 'Invoice' },
    { name: 'Phone Numbers', href: '/admin/phone-numbers', icon: 'Phone' },
    { name: 'Calling Providers', href: '/admin/calling-providers', icon: 'Calling' },
    { name: 'API Keys', href: '/admin/api-keys', icon: 'Key' },
    { name: 'Workflows', href: '/admin/workflows', icon: 'Workflow' },
    { name: 'Workflow Health', href: '/admin/workflow-health', icon: 'Monitoring' },
    { name: 'Integrations', href: '/admin/integrations', icon: 'Plug' },
    { name: 'System', href: '/admin/system', icon: 'Settings' },
    { name: 'Monitoring', href: '/admin/monitoring', icon: 'Monitoring' },
    { name: 'FastAPI Monitoring', href: '/admin/fastapi-monitoring', icon: 'Terminal' },
  ];

  return (
    <div className="min-h-screen bg-admin-50">
      {/* Sidebar */}
      <AdminSidebar 
        navigation={navigation}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      {/* Main content */}
      <div className="lg:pl-64">
        {/* Header */}
        <AdminHeader 
          setSidebarOpen={setSidebarOpen}
          navigation={navigation}
        />

        {/* Page content */}
        <main className="py-6">
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

